import Summary from "./index";

import {useEffect, useRef, useState} from "react";
import {useVersionContext} from "../../context/GlobalContext";
import SelfIntroduction2 from "./selfIntroduction2";
import {BTN_KEY} from "../../util/util";
import Others2 from "./others2";
import Projects2 from "./projects2";
import version2mainImg from "../../assets/version2main.jpg"

const AllSummary2 = ({btnKey, changeBtnKey}) => {
    const {getVersion} = useVersionContext();
    const [canAllShow, setCanAllShow] = useState(false);
    // const activeTarget = 'choice-summary-4';
    const focusRef = useRef();

    useEffect(() => {
        setCanAllShow(false);
    }, [btnKey])

    return (
        <div className="fade-item delay-10" ref={focusRef}>
            {getVersion() === 2 && (
                <>
                    {btnKey === BTN_KEY.DEFAULT && <>
                        {/*<hr className='featurette-divider'/>*/}
                        <div className="d-flex justify-content-center mt-3 align-items-center">
                            <img
                                src={version2mainImg}
                                alt="version2mainImg"
                                className="custom-version2mainImg mb-3 bd-placeholder-img bd-placeholder-img-lg featurette-image img-fluid mx-auto"
                                width="1000"
                                height="1000"
                            />
                        </div>
                    </>}
                    {btnKey === BTN_KEY.INTRO && <SelfIntroduction2 changeBtnKey={changeBtnKey}/>}
                    {btnKey === BTN_KEY.SPEC && <Others2 changeBtnKey={changeBtnKey}/>}
                    {btnKey === BTN_KEY.PROJECT && <Projects2 changeBtnKey={changeBtnKey}/>}
                    {btnKey === BTN_KEY.ALL && (
                        <>
                            <Others2
                                changeBtnKey={changeBtnKey}
                                setCanAllShow={setCanAllShow}
                                allMode/>
                            {canAllShow && (
                                <>
                                    <SelfIntroduction2 allMode/>
                                    <Projects2 allMode/>
                                </>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default AllSummary2;